import { fileApi } from "@/getinfo-api";
import { BaseFile as IBaseFile } from "@/api-v2/files/models/base-file";
import { ModelFile as IModelFile } from "@/api-v2/files/models/model-file";
import { FileItem as IFileItem } from "@/api/models/file-item";
type FileType = IFileItem | (IBaseFile & IModelFile);

let inProgress: boolean = false;

const insertStringByIndex = (
  index: number,
  value: string,
  addedValue: string
) => {
  if (index && index > 0) {
    return value.substring(0, index) + addedValue + value.substr(index);
  }
  return value;
};

const random = () => Math.floor(Math.random() * (59 + 1));

const getInformationFromUrl = (url: string) => {
  const searchedString = "disks/";
  const searchedStringLength = searchedString.length;

  let urlLength = url.length;

  const firstIndex = url.lastIndexOf("disks/");

  const stringWithoutBasePath = url.substring(
    firstIndex + searchedStringLength,
    urlLength
  );

  const separatedPath = stringWithoutBasePath.split("/");

  const diskId = separatedPath[0];

  const pathWithoutDiskId = separatedPath.slice(1)?.join("/");

  const name = separatedPath[separatedPath.length - 1];

  return { diskId: diskId, path: pathWithoutDiskId, name: name };
};

const fileInformation = (file: FileType) => {
  return {
    diskId: getInformationFromUrl(file.url!).diskId,
    path: getInformationFromUrl(file.url!).path,
    name: getInformationFromUrl(file.url!).name
  };
};

const getFileName = (file: FileType) => {
  return fileInformation(file).name;
};

const generatePdf = async (file: FileType) => {
  try {
    inProgress = true;
    const name = fileInformation(file).name;
    const nameIndex = fileInformation(file).path.indexOf(name);
    let pathWithPdf = insertStringByIndex(
      nameIndex,
      fileInformation(file).path,
      "pdf/"
    );

    const arr = pathWithPdf.split(".");

    arr[arr.length - 1] = `(${random()}).pdf`;
    const newPath = arr.join(".");

    const body = {
      path: newPath
    };
    const { data } = await fileApi.ConvertApi.convertToPdf(file.id, body);
    return data;
  } catch (e) {
    throw Error(e);
  } finally {
    inProgress = false;
  }
};

export { inProgress, generatePdf, getFileName, FileType, fileInformation };
